/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'atm': {
    width: 110,
    height: 110,
    viewBox: '0 0 110 110',
    data: '<path pid="0" d="M19.972 35.25l-12.99 66a7.332 7.332 0 007.199 8.751h14.924c2.75-26.889 5.505-53.778 8.265-80.667H27.172a7.342 7.342 0 00-7.2 5.916z" _fill="#2B363B"/><path pid="1" d="M0 36.667v-33A3.668 3.668 0 013.667 0h102.666A3.667 3.667 0 01110 3.667v33a3.667 3.667 0 01-3.667 3.666h-9.08L95.81 33h6.856V7.333H7.333V33h6.856l-1.442 7.333h-9.08A3.668 3.668 0 010 36.667zM95.82 110H46.367l2.75-80.667H82.83a7.342 7.342 0 017.2 5.916l12.99 66a7.331 7.331 0 01-7.2 8.751zM75.11 93.357l-.693-11.1a1.817 1.817 0 00-1.81-1.7H59.693c-.993 0-1.804.802-1.814 1.795l-.105 11.1a1.815 1.815 0 001.814 1.834H73.3c.502 0 .98-.21 1.323-.573.344-.368.52-.855.487-1.356zm21.446-75.024a3.668 3.668 0 00-3.667-3.666H17.11a3.668 3.668 0 000 7.333H92.89a3.668 3.668 0 003.667-3.667z" _fill="#2B363B"/>'
  }
})
